import { fetchData, getUserId } from "../common_utilities";
import { taxplanningEndpoints } from "../constants";
import { apiCall } from "../common_utilities";
import { conversionFun } from "../Pages/wpPages/common/conversionFun";
import { generateLead } from "../FrappeIntegration-Services/services/user-management-api/userApiService";

export const calendlyCallbackFun = async (scheduleData, addIncomSlabAndComment) => {

  const urlParams = new URLSearchParams(window.location.search);
  let utm_source_value = urlParams.get("utm_source");
  let tags_value = urlParams.get("tags");
  if (utm_source_value) {
    utm_source_value = utm_source_value + ''
  }
  if (tags_value) {
    tags_value = tags_value + ''
  }

  const incomeSlabAnswers = ['$60K to $100K', '$100K to $500K', '$500K & Above'];
  const incomeSlabAnswersuae = ['0 to 45k AED', '45k to 155k AED', '155k to 222k AED', '222k to 444k AED', 'Above 444K AED'];
  const incomeSlabAnswerslandingPage = ['0 to 10 Lac', '10 Lac to 25 Lac', '25 Lac to 50 Lac', '50 Lac to 1 Crore', 'Above 1 Crore'];
  const incomeSlabAnswerswealthmanagementlandingPage = ['0 to 25K AED', '25K to 50 AED', '50K AED & Above'];
  const incomeSlabAnswerspersonalfinancepage = ['0 to 25K AED', '25K to 50K AED', '50K AED & Above'];
  const incomeSlabAnswersITRPage = ['0 to 10 Lakhs', '10 to 25 Lakhs', '25 to 50 Lakhs', '50 Lakhs to 1 Crore', '1 Crore and Above'];
  try {
  
    const isWP = scheduleData.isWP;
    const eventURL = scheduleData.eventURL;
    const eventURL2 = scheduleData.eventURL2;
    const eventType = scheduleData.eventType;
    // const serviceName = scheduleData.serviceName;
    const planId = scheduleData.planId;
    const extraParams = scheduleData.extraParams == null ? {} : scheduleData.extraParams;

    const email = scheduleData.email;
    const fullname = scheduleData.fullname;
    const mobileNumber = scheduleData.mobileNumber;

    console.log("scheduleData", scheduleData)

    if (eventURL == null) return;

    if (eventType == null) {
      eventType = "Callback_mintyApp_8";
    }
    if (scheduleData.serviceName == null) {
      scheduleData.serviceName = "Financial Planning";
    }
    // Check if the page URL is "web/wealth-management"
    const isWealthManagementPage = window.location.pathname.indexOf("web/wealth-management") > -1;

    const incomeQuestion = isWealthManagementPage ? "Monthly Income" : "Income Slab";

    const r = await fetchData({
      url: eventURL,
      method: "GET",
      headers: {
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ4MjExMjQ0LCJqdGkiOiJmMmM1YWIwOC01N2ZiLTQ0YzAtODNjYy1lM2QxZWZhZGY2YzMiLCJ1c2VyX3V1aWQiOiI0ODVhZTAyZC02ZGNiLTQ1MjktODdiYi01MGY2NDE3NGI4ZWYifQ.5bIIwHH3DTn1Vp7Oj6hZlLkVIbI1q7jxqFogGaGkb1g",
      },
    });

    const inviteeDetails = r.resource;

    let payload;

    if (isWP) {

      const incomeSlabArr = r.resource.questions_and_answers.filter(
        (v) => v.question.toLowerCase().indexOf(incomeQuestion.toLowerCase()) > -1
      );

      const getIncomSlabNo = (slabTxt) => {
        switch (slabTxt) {
          case '0 to 10 Lacs':
            return 1
          case '10 to 25 Lacs':
            return 2
          case '25 to 50 Lacs':
            return 3
          case '50 to 1 Cr':
            return 4
          case 'Above 1 Crore':
            return 5
          default:
            return 1
        }
      }

      const getDefaultTag = (service) => {
        switch (service + '') {
          case '100':
            return 'reg_fp'
          case '26':
            return 'reg_wm'
          default:
            return 'reg_fp'
        }
      }

      payload = {
        full_name: fullname ? fullname : r.resource.name,
        email: email ? email : r.resource.email,
        services: [extraParams.plan_name ?? scheduleData.serviceName],
        source : '',
        tags: tags_value ? tags_value : getDefaultTag(extraParams.service),
        mobile: mobileNumber ? mobileNumber : "",
        rm_id: "",
        source : "Website Callback",
        slab: incomeSlabArr ? getIncomSlabNo(incomeSlabArr[0]?.answer ?? '') : 1,
        user_id : getUserId()

      };
    } else {
      payload = {
        full_name: fullname ? fullname : r.resource.name,
        email: email ? email : r.resource.email,
        // tagval: "",
        services: [scheduleData.serviceName],
        source : '',
        // tags: eventType,
        source : "Website Callback",
        mobile: mobileNumber ? mobileNumber : "",
        rm_id: "",
        user_id : getUserId(),
        // slab: incomeSlabArr ? getIncomSlabNo(incomeSlabArr[0]?.answer ?? '') : 1
        ...extraParams
      };
    }

    console.log("Payload", payload)

    const incomeSlab = r.resource.questions_and_answers.filter(
      (v) => v.question.toLowerCase().indexOf(incomeQuestion.toLowerCase()) > -1
    );

    if (incomeSlab.length > 0) {
      let answer = incomeSlab[0]['answer'].split(" ").filter(v => v).join(" "); 
    
      if (!isWP) {
        if (incomeSlabAnswers.includes(answer)) {
          payload.slab = incomeSlabAnswers[incomeSlabAnswers.indexOf(answer)];
        } else if (incomeSlabAnswerslandingPage.includes(answer)) {
          payload.slab = incomeSlabAnswerslandingPage[incomeSlabAnswerslandingPage.indexOf(answer)];
        } else if (incomeSlabAnswersITRPage.includes(answer)) {
          payload.slab = incomeSlabAnswersITRPage[incomeSlabAnswersITRPage.indexOf(answer)];
        } else if (incomeSlabAnswersuae.includes(answer)) {
          payload.slab = incomeSlabAnswersuae[incomeSlabAnswersuae.indexOf(answer)];
        } else if (incomeSlabAnswerswealthmanagementlandingPage.includes(answer)) {
          payload.slab = incomeSlabAnswerswealthmanagementlandingPage[incomeSlabAnswerswealthmanagementlandingPage.indexOf(answer)];
        } else if (incomeSlabAnswerspersonalfinancepage.includes(answer)) {
          payload.slab = incomeSlabAnswerspersonalfinancepage[incomeSlabAnswerspersonalfinancepage.indexOf(answer)];
        } else {
          payload.slab = ""; 
        }
      }
    }
    

    if (addIncomSlabAndComment) {
      if (!isWP) {
        payload.portfolio_slab = r.resource.questions_and_answers[2]

        if (r.resource.questions_and_answers[1]?.answer == "0  to 10  Lakhs" || r.resource.questions_and_answers[1]?.answer == "0-10 LPA") {
          payload.portfolio_slab = 1;
        }
        if (r.resource.questions_and_answers[1]?.answer == "10 Lakhs to 25 Lakhs" || r.resource.questions_and_answers[1]?.answer == "10-25 LPA") {
          payload.portfolio_slab = 2;
        }
        if (r.resource.questions_and_answers[1]?.answer == "25 Lakhs to 50 Lakhs" || r.resource.questions_and_answers[1]?.answer == "25-50 LPA") {
          payload.portfolio_slab = 3;
        }
        if (r.resource.questions_and_answers[1]?.answer == "50 Lakhs to 1 Crore" || r.resource.questions_and_answers[1]?.answer == "50 Lacs - 1 Crore PA") {
          payload.portfolio_slab = 4;
        }
        if (r.resource.questions_and_answers[1]?.answer == "Above 1 Crore" || r.resource.questions_and_answers[1]?.answer == "More than 1 Crore PA") {
          payload.portfolio_slab = 5;
        }

        payload.comment = r.resource.questions_and_answers[1]?.answer ?? "";
      }
    }


    if (!scheduleData.loggedIn) {
      const user_register_payload = {
        "fullname": fullname ? fullname : r.resource.name,
        "mobile": mobileNumber ? mobileNumber : "",
        "email": email ? email : r.resource.email,
        "country_code": "91",
        "tags": "fin_web_reg",
        "utm_source": utm_source_value ? utm_source_value : 27 + '',
        "service": "98",
        "skip_mail": "1",
        "rm_id": "96",
        "react": "1",
        "plan_id": "",
        "is_expert": "1"
      }

      // await apiCall(
      //   BASE_API_URL + "restapi/UserRegisterApi/",
      //   user_register_payload,
      //   false,
      //   false
      // );
    }

    const r1 = await generateLead(payload);

    if (r1.error_code == "0") {

      if (isWP) {
        conversionFun('AW-948765509', 'xQivCMC_6cADEMWGtMQD');
      }

      const r = await fetchData({
        url: eventURL2,
        method: "GET",
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ4MjExMjQ0LCJqdGkiOiJmMmM1YWIwOC01N2ZiLTQ0YzAtODNjYy1lM2QxZWZhZGY2YzMiLCJ1c2VyX3V1aWQiOiI0ODVhZTAyZC02ZGNiLTQ1MjktODdiYi01MGY2NDE3NGI4ZWYifQ.5bIIwHH3DTn1Vp7Oj6hZlLkVIbI1q7jxqFogGaGkb1g",
        },
      });


      // ======================================= web engage ====================================================

      function transformGuestEmails(data) {
        const guests = {};
        data.forEach((item, index) => {
          guests[`guest${index + 1}`] = item.email || null;
        });

        return [guests];

      }

      const callbackEventData = {
        "lead_id": r1.data.log_id,
        "name": fullname ? fullname : r.resource.name,
        "email": email ? email : r.resource.email,
        "guest_emails": transformGuestEmails(r.resource.event_guests),
        "phone": mobileNumber ? mobileNumber : "",
        "asset_size": inviteeDetails?.questions_and_answers[1]?.answer ?? '',
        "text_pone": mobileNumber ? mobileNumber : "",
        "date_selected": new Date(r.resource.start_time),
        "time_selected": new Date(r.resource.start_time),
        "timezone": inviteeDetails?.timezone ?? '',
        "continent": inviteeDetails?.timezone ?? '',
        "page_url": window.location.href ?? '',
        "utm_source": utm_source_value ? utm_source_value : 27 + ''
      }

      webengage.user.login(r1.data.u_id);

      webengage.user.setAttribute('we_first_name', fullname ? fullname : r.resource.name);
      webengage.user.setAttribute('we_email', email ? email : r.resource.email);
      webengage.user.setAttribute('we_phone', mobileNumber ? mobileNumber : "");
      webengage.user.setAttribute('PortfolioSlab', "");
      webengage.user.setAttribute('IncomeSlab', inviteeDetails?.questions_and_answers[1]?.answer ?? '');
      webengage.user.setAttribute('LeadDate', new Date());
      webengage.user.setAttribute('LeadStatus', "Introductory meet");
      webengage.user.setAttribute('Tag', eventType);
      webengage.user.setAttribute('we_email_opt_in', true); //Email
      webengage.user.setAttribute('we_sms_opt_in', true); //SMS

      const checked = JSON.parse(localStorage.getItem('subscribenotificationsChecked'));
      webengage.user.setAttribute('we_whatsapp_opt_in', checked); //WhatsApp
      localStorage.removeItem('subscribenotificationsChecked');

      webengage.track("appointment scheduled", callbackEventData);

      // ======================================= web engage ====================================================
      const appointmentScheduledData = {
        date: (new Date(r.resource.start_time)).toLocaleDateString('en-ca'),
        time: ((new Date(r.resource.start_time)).toLocaleTimeString('en-US', { hour12: false })),
        meeting_link: '',
        appointment_uri: r.resource.uri,
        income_slab: payload.data.slab
      }

      const payload_data = {
        "appointment_user_id": r1.data.u_id,
        "appointment_plan_uuid": planId,
        "appointment_date": appointmentScheduledData.date,
        "income_slab": appointmentScheduledData.income_slab,
        "appointment_expert_id": "EMPM-1"
      }

      await apiCall(
        taxplanningEndpoints.CREATE_APPOINTMENT_DETAILS,
        payload_data,
        false,
        false
      );

    }
  } catch (e) {
    console.error("Error in calendlyCallbackFun:", e);
  }
};

